import {
  BarChart3,
  Building2,
  FileBarChart2,
  FlaskConical,
  Globe2,
  Home,
  Key,
  Microscope,
  Settings2,
  Users,
} from "lucide-react";

/**
 * Definición del menú lateral.
 *
 * El `name` es SOLO texto visible: nunca se usa para autorizar. Antes el filtro
 * comparaba nombres en español (`["Dashboard","Usuarios"].includes(item.name)`),
 * de modo que renombrar una entrada del menú cambiaba silenciosamente quién la
 * veía. Ahora cada entrada apunta a una ruta por su id y hereda el permiso que
 * esa ruta declara en `src/app/routes.tsx`.
 */
export interface NavItemDef {
  /** Id de la ruta en `APP_ROUTES`. De ahí sale el permiso. */
  readonly routeId: string;
  /** Texto visible. No participa en la autorización. */
  readonly name: string;
  readonly icon: React.ComponentType<{ className?: string }>;
  readonly children?: readonly NavItemDef[];
  /** Si va al menú "Más" de la barra inferior en móvil. */
  readonly mobileOverflow?: boolean;
  /**
   * Ruta de destino cuando difiere de la de `routeId`. Se usa para el padre
   * "Reportes", que enlaza a `/reports` y este redirige a su primer hijo.
   */
  readonly hrefOverride?: string;
}

export const NAVIGATION: readonly NavItemDef[] = [
  { routeId: "dashboard", name: "Dashboard", icon: Home },
  { routeId: "users", name: "Usuarios", icon: Users },
  { routeId: "licenses", name: "Licencias", icon: Key },
  { routeId: "dns", name: "DNS", icon: Globe2 },
  { routeId: "settings-platform", name: "Configuración", icon: Settings2 },
  { routeId: "laboratory", name: "Laboratorio", icon: FlaskConical },
  { routeId: "bioanalysis", name: "Bioanálisis", icon: Microscope },
  {
    routeId: "reports-business",
    name: "Reportes",
    icon: BarChart3,
    hrefOverride: "/reports",
    children: [
      {
        routeId: "reports-business",
        name: "Reportes de Negocio",
        icon: Building2,
      },
      {
        routeId: "servers-report",
        name: "Inventario software",
        icon: FileBarChart2,
      },
    ],
  },
];
